<div class="backpage-wrapper">
  <div class="individual-sub-container">
    <div class="header">
      <img
        src="../../../../../assets/Logos/zentra_logo-removebg-preview 1.png"
        alt="zentra green logo"
        width="50"
        height="50"
      />
      <h1>Zentra Subscriptions - Admin Portal</h1>
    </div>

    <!-- Subscription Details Section -->
    <div class="details-section">
      <div class="section-header">
        <mat-icon>info</mat-icon>
        <h3>Subscription Details</h3>
      </div>
      <div class="section-content">
        <div class="details-grid">
          <div class="detail-item">
            <span class="label">Subscription ID:</span>
            <span class="value">{{ subscriptionData?.subscriptionId }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Amount Paid:</span>
            <span class="value">${{ subscriptionData?.amount }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Description:</span>
            <span class="value">{{ subscriptionData?.subscriptionPlan }}</span>
          </div>
          <div class="detail-item">
            <span class="label">SKU/Item:</span>
            <span class="value">{{ subscriptionData?.sku }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Customer/Wholesaler:</span>
            <span class="value">{{ subscriptionData?.wholeSalerAccount }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Start Date:</span>
            <span class="value"
              >{{ subscriptionData?.startDate | date: 'MM/dd/yyyy' }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Property and PO Information Row -->
    <div class="top-2-section">
      <!-- Property Information -->
      <div class="property-section">
        <div class="section-header-with-action">
          <div class="left-aligned">
            <mat-icon>business</mat-icon>
            <h3>Property Information</h3>
          </div>
          <button mat-button class="edit-button" (click)="togglePropertyEdit()">
            {{ isPropertyEditMode ? 'Cancel' : 'Edit' }}
          </button>
        </div>
        <div class="property-section-content">
          <div class="detail-item">
            <span class="label">Property Name:</span>
            <span *ngIf="!isPropertyEditMode" class="value"
              >{{ subscriptionData?.propertyName }}</span
            >
            <input
              *ngIf="isPropertyEditMode"
              [(ngModel)]="subscriptionData!.propertyName"
              type="text"
              [class.invalid]="isFieldInvalid('propertyName')"
            />
          </div>
          <div class="detail-item">
            <span class="label">Property Address:</span>
            <span *ngIf="!isPropertyEditMode" class="value"
              >{{ subscriptionData?.propertyAddress }}</span
            >
            <input
              *ngIf="isPropertyEditMode"
              [(ngModel)]="subscriptionData!.propertyAddress"
              type="text"
              [class.invalid]="isFieldInvalid('propertyAddress')"
            />
          </div>
          <div class="detail-item">
            <span class="label">Property Main Point of Contact:</span>
            <span *ngIf="!isPropertyEditMode" class="value"
              >{{ subscriptionData?.propertyMainPoc }}</span
            >
            <input
              *ngIf="isPropertyEditMode"
              [(ngModel)]="subscriptionData!.propertyMainPoc"
              type="text"
              [class.invalid]="isFieldInvalid('propertyMainPoc')"
            />
          </div>
          <div class="detail-item">
            <span class="label">Property Main Point of Contact Email:</span>
            <span *ngIf="!isPropertyEditMode" class="value"
              >{{ subscriptionData?.propertyMainPocEmail }}</span
            >
            <input
              *ngIf="isPropertyEditMode"
              [(ngModel)]="subscriptionData!.propertyMainPocEmail"
              type="email"
              [class.invalid]="isFieldInvalid('propertyMainPocEmail')"
            />
          </div>
          <div class="detail-item">
            <span class="label"># of Unit Devices:</span>
            <span *ngIf="!isPropertyEditMode" class="value"
              >{{ subscriptionData?.unitDeviceQuantity }}</span
            >
            <input
              *ngIf="isPropertyEditMode"
              [(ngModel)]="subscriptionData!.unitDeviceQuantity"
              type="number"
              min="0"
              [class.invalid]="isFieldInvalid('unitDeviceQuantity')"
            />
          </div>
          <div class="detail-item">
            <span class="label"># of Common Area/Perimeter Devices:</span>
            <span *ngIf="!isPropertyEditMode" class="value"
              >{{ subscriptionData?.commonAreaDeviceQuantity }}</span
            >
            <input
              *ngIf="isPropertyEditMode"
              [(ngModel)]="subscriptionData!.commonAreaDeviceQuantity"
              type="number"
              min="0"
              [class.invalid]="isFieldInvalid('commonAreaDeviceQuantity')"
            />
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="label">Engage Migration?:</span>
              <span *ngIf="!isPropertyEditMode" class="value"
                >{{ subscriptionData?.isEngageMigration }}</span
              >
              <input
                *ngIf="isPropertyEditMode"
                [(ngModel)]="subscriptionData!.isEngageMigration"
                type="text"
              />
            </div>
            <div class="detail-item">
              <span class="label">Engage SiteId:</span>
              <span *ngIf="!isPropertyEditMode" class="value"
                >{{ subscriptionData?.siteId }}</span
              >
              <input
                *ngIf="isPropertyEditMode"
                [(ngModel)]="subscriptionData!.siteId"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- PO Information -->
      <div class="po-section">
        <div class="section-header">
          <mat-icon>receipt_long</mat-icon>
          <h3>PO Information</h3>
        </div>
        <div class="po-section-content">
          <div class="detail-item">
            <span class="label">PO Number:</span>
            <span class="value">{{ subscriptionData?.poNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Invoice Number:</span>
            <span class="value">{{ subscriptionData?.invoiceNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Invoice Date:</span>
            <span class="value"
              >{{ subscriptionData?.startDate | date: 'MM/dd/yyyy' }}</span
            >
          </div>
          <div class="detail-item">
            <span class="label">Sales Order Number:</span>
            <span class="value">{{ subscriptionData?.soNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Amount Paid:</span>
            <span class="value">${{ subscriptionData?.amount }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Integrator Information -->
    <div class="integrator-section">
      <div class="section-header-with-action">
        <div class="left-aligned">
          <mat-icon>engineering</mat-icon>
          <h3>Integrator Information</h3>
        </div>
        <button mat-button class="edit-button" (click)="toggleIntegratorEdit()">
          {{ isIntegratorEditMode ? 'Cancel' : 'Edit' }}
        </button>
      </div>
      <div class="integrator-section-content">
        <div class="integrator-grid">
          <div class="detail-item">
            <span class="label">Company Name:</span>
            <span *ngIf="!isIntegratorEditMode" class="value"
              >{{ subscriptionData?.integratorCompanyName }}</span
            >
            <input
              *ngIf="isIntegratorEditMode"
              [(ngModel)]="subscriptionData!.integratorCompanyName"
              type="text"
              [class.invalid]="isFieldInvalid('integratorCompanyName')"
            />
          </div>
          <div class="detail-item">
            <span class="label">Integrator Main Point of Contact:</span>
            <span *ngIf="!isIntegratorEditMode" class="value"
              >{{ subscriptionData?.integratorMainPoc }}</span
            >
            <input
              *ngIf="isIntegratorEditMode"
              [(ngModel)]="subscriptionData!.integratorMainPoc"
              type="text"
              [class.invalid]="isFieldInvalid('integratorMainPoc')"
            />
          </div>
          <div class="detail-item">
            <span class="label">Integrator Main Point of Contact Email:</span>
            <span *ngIf="!isIntegratorEditMode" class="value email-text"
              >{{ subscriptionData?.integratorMainPocEmail }}</span
            >
            <input
              *ngIf="isIntegratorEditMode"
              [(ngModel)]="subscriptionData!.integratorMainPocEmail"
              type="email"
              [class.invalid]="isFieldInvalid('integratorMainPocEmail')"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    @if (updateErrorMessage) {
    <div class="error-message">
      <mat-icon>error_outline</mat-icon>
      <div class="error-content">
        <strong>Update Failed</strong>
        <p>{{ updateErrorMessage }}</p>
      </div>
    </div>
    }

    <!-- Success Message -->
    @if (updateSuccessMessage) {
    <div class="success-message">
      <mat-icon>check_circle_outline</mat-icon>
      <div class="success-content">
        <strong>Update Successful</strong>
        <p>{{ updateSuccessMessage }}</p>
      </div>
    </div>
    }

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button mat-button class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button
        mat-flat-button
        color="primary"
        class="update-button"
        (click)="updateSubscription()"
        [disabled]="!canUpdate()"
      >
        Update
      </button>
    </div>
  </div>
</div>
